// extracted by mini-css-extract-plugin
export default {"logsPage":"LogsPage_logsPage__zz1K5"};